import { useEffect, useRef, useState } from "react";

const FileUploader = ({ accept = "*", onFileChange, error, value }) => {
  const refInputFile = useRef(
    `file-uploader-${Math.random().toString(36).substr(2, 9)}`
  );
  const [file, setFile] = useState(null);
  const [dragActive, setDragActive] = useState(false);

  const handleChangeFile = (event) => {
    const selectedFile = event.target.files?.[0] || null;
    setFile(selectedFile);
    onFileChange(selectedFile);
  };

  const handleDragEnter = (event) => {
    event.preventDefault();
    setDragActive(true);
  };

  const handleDragLeave = (event) => {
    event.preventDefault();
    setDragActive(false);
  };

  const handleDragOver = (event) => {
    event.preventDefault();
  };

  const handleDrop = (event) => {
    event.preventDefault();
    setDragActive(false);

    const droppedFile = event.dataTransfer.files?.[0] || null;
    setFile(droppedFile);
    onFileChange(droppedFile);
  };

  const handleRemoveFile = () => {
    setFile(null);
    onFileChange(null);
    if (refInputFile.current) refInputFile.current.value = "";
  };

  useEffect(() => {
    if (!value) {
      setFile(null);
      refInputFile.current.value = "";
    }
  }, [value]);

  return (
    <div className="upload-container">
      <input
        ref={refInputFile}
        type="file"
        id={`file-upload`}
        hidden
        accept={accept}
        onChange={handleChangeFile}
      />

      {file ? (
        <div className="preview-container">
          {file.type.startsWith("image/") ? (
            <img
              src={URL.createObjectURL(file)}
              alt="Preview"
              className="preview-image"
            />
          ) : (
            <p className="text-center">Archivo seleccionado: {file.name}</p>
          )}
          <button className="remove-button" onClick={handleRemoveFile}>
            Eliminar
          </button>
        </div>
      ) : (
        <label
          htmlFor={`file-upload`}
          className={`upload-area ${dragActive ? "border-primary" : ""} ${
            error ? "border-danger" : ""
          }`}
          onDragEnter={handleDragEnter}
          onDragLeave={handleDragLeave}
          onDragOver={handleDragOver}
          onDrop={handleDrop}
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 24 24"
            fill="currentColor"
            className="upload-icon"
          >
            <path
              fillRule="evenodd"
              d="M12 2a.75.75 0 01.75.75V14.5h2.69a.75.75 0 01.53 1.28l-4 4.25a.75.75 0 01-1.06 0l-4-4.25a.75.75 0 01.53-1.28h2.69V2.75A.75.75 0 0112 2z"
              clipRule="evenodd"
            />
          </svg>
          <p className={`text-center ${error ? "text-danger" : ""}`}>
            Arrastra y suelta un archivo aquí o{" "}
            <span className={`${error ? "text-danger" : ""}`}>
              haz clic para seleccionar
            </span>
          </p>
          {error && <p className="text-danger mt-2">{error}</p>}
        </label>
      )}
    </div>
  );
};

export default FileUploader;
